module.exports = __webpack_public_path__ + "static/media/praiseClear.8ca037b3.svg";